module.exports = __webpack_public_path__ + "img/tomain.e845bbe2.png";